import * as React from "react";

import { Button } from "@progress/kendo-react-buttons";
import { menuIcon } from "@progress/kendo-svg-icons";

export default function DrawerMenuButton() {
  return <Button svgIcon={menuIcon} />;
}
